"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VillesEtQuartiers() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  interface NeighborhoodItem {
    name: string;
    href?: string;
  }
  interface Region {
    label: string;
    heading: string;
    response: string;
    neighborhoods: NeighborhoodItem[];
  }
  const regions: Region[] = [{
    label: "[ SECTEUR MONTRÉAL ]",
    heading: "Montréal & Centre",
    response: "[ RÉPONSE MOY. : 30 MIN ]",
    neighborhoods: [{
      name: "Plateau Mont-Royal"
    }, {
      name: "Villeray"
    }, {
      name: "Rosemont"
    }, {
      name: "Ahuntsic"
    }, {
      name: "Saint-Léonard"
    }, {
      name: "Anjou"
    }, {
      name: "Ville-Marie"
    }, {
      name: "Griffintown"
    }, {
      name: "Hochelaga"
    }, {
      name: "Saint-Laurent"
    }]
  }, {
    label: "[ RIVE-NORD & LAVAL ]",
    heading: "Laval & Couronne Nord",
    response: "[ RÉPONSE MOY. : 45 MIN ]",
    neighborhoods: [{
      name: "Laval",
      href: "/debouchage-de-drains-a-laval"
    }, {
      name: "Chomedey"
    }, {
      name: "Sainte-Dorothée"
    }, {
      name: "Vimont"
    }, {
      name: "Pont-Viau"
    }, {
      name: "Blainville"
    }, {
      name: "Terrebonne"
    }, {
      name: "Repentigny",
      href: "/debouchage-de-drains-a-repentigny"
    }, {
      name: "Mirabel"
    }, {
      name: "Saint-Eustache"
    }, {
      name: "Sainte-Thérèse"
    }, {
      name: "Boisbriand"
    }]
  }, {
    label: "[ RIVE-SUD ]",
    heading: "Longueuil & Couronne Sud",
    response: "[ RÉPONSE MOY. : 40 MIN ]",
    neighborhoods: [{
      name: "Longueuil",
      href: "/debouchage-de-drains-a-longueuil"
    }, {
      name: "Vieux-Longueuil"
    }, {
      name: "Brossard",
      href: "/debouchage-de-drains-a-brossard"
    }, {
      name: "Saint-Hubert"
    }, {
      name: "Boucherville"
    }, {
      name: "Saint-Lambert"
    }, {
      name: "Candiac"
    }, {
      name: "La Prairie"
    }, {
      name: "Châteauguay"
    }, {
      name: "Sainte-Julie"
    }, {
      name: "Beloeil"
    }]
  }];
  return <section data-section-id="859" id="villes-et-quartiers" className="bg-background text-foreground py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {}
        <div ref={headerRef} className={`max-w-3xl mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs tracking-widest text-primary mb-6">
            [ ZONES DE SERVICE ]
          </p>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl leading-tight text-foreground mb-6 font-semibold tracking-tighter">
            Le Grand Montréal.{" "}
            <em className="text-primary not-italic font-default italic">
              Une expertise ciblée.
            </em>
          </h2>
          <p className="text-muted-foreground text-base md:text-lg leading-relaxed max-w-2xl font-default">
            De l&apos;effervescence du centre-ville de Montréal aux quartiers résidentiels de Laval et de la Rive-Sud, OT Solution intervient avec précision pour vos débouchages et inspections par caméra 24/7.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {regions.map((region, i) => {
          const half = Math.ceil(region.neighborhoods.length / 2);
          const colA = region.neighborhoods.slice(0, half);
          const colB = region.neighborhoods.slice(half);
          return <div key={region.heading} data-index={i} className="group relative bg-card border border-border rounded-md p-8 flex flex-col transition-all duration-300 hover:shadow-lg hover:-translate-y-1 overflow-hidden">
                {}
                <p className="font-mono text-xs tracking-widest text-primary mb-4">
                  {region.label}
                </p>

                {}
                <h3 className="font-default text-2xl text-foreground mb-5 leading-tight font-semibold">
                  {region.heading}
                </h3>

                {}
                <div className="h-px w-full bg-border mb-6" />

                {}
                <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 mb-8 flex-1">
                  {colA.map((item, idx) => item.href ? <Link key={`a-${idx}`} href={item.href} className="text-[15px] text-foreground hover:text-primary hover:underline underline-offset-4 transition-colors font-default">
                        {item.name}
                      </Link> : <Link key={`a-${idx}`} to="/ServicedAreasPage" className="text-[15px] text-foreground hover:text-primary hover:underline underline-offset-4 transition-colors font-default">
                        {item.name}
                      </Link>)}
                  {colB.map((item, idx) => item.href ? <Link key={`b-${idx}`} href={item.href} className="text-[15px] text-foreground hover:text-primary hover:underline underline-offset-4 transition-colors font-default">
                        {item.name}
                      </Link> : <Link key={`b-${idx}`} to="/ServicedAreasPage" className="text-[15px] text-foreground hover:text-primary hover:underline underline-offset-4 transition-colors font-default">
                        {item.name}
                      </Link>)}
                </div>

                {}
                <div className="flex items-center justify-between pt-4 border-t border-border">
                  <span className="font-mono text-[10px] md:text-xs tracking-widest text-muted-foreground">
                    {region.response}
                  </span>
                  <Button asChild variant="ghost" size="sm" className="text-foreground hover:text-primary hover:bg-transparent px-0 h-auto font-default">
                    <Link to="/ContactPage" className="inline-flex items-center gap-1.5 text-sm">
                      Réserver ici
                      <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
                    </Link>
                  </Button>
                </div>

                {}
                <span className="absolute bottom-0 left-0 h-px w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full" />
              </div>;
        })}
        </div>

        {}
        <div className="mt-16 flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-10 border-t border-border">
          <p className="font-mono text-xs tracking-widest text-muted-foreground">
            [ VOTRE VILLE N&apos;EST PAS LISTÉE? APPELEZ-NOUS — NOUS COUVRONS SÛREMENT VOTRE SECTEUR. ]
          </p>
          <Button asChild variant="outline" className="border-border text-foreground hover:bg-accent rounded-md font-default">
            <Link to="tel:438-367-8309" className="inline-flex items-center gap-2">
              Appeler 438-367-8309
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}